import classnames from 'classnames';

import { addQueryParamToSrcset, addQueryParamToUrl } from '@common/utils/url';
import { DatoImageFile } from '@interfaces';

import styles from './image.module.scss';

type ImageProps = {
	className?: string;
	hasCaption?: boolean;
	image: DatoImageFile;
	loading?: 'lazy';
	sizes: string;
	blurred?: boolean;
};

export const Image = ({
	className,
	hasCaption = true,
	image,
	loading,
	sizes,
	blurred = false,
}: ImageProps) => {
	const { responsiveImage, alt, height, width, title } = image;

	if (!responsiveImage) {
		return null;
	}

	let { src, srcSet } = responsiveImage;

	if (blurred) {
		// Makes the gaussian blur filter size relative to the image size for consistent blur intensity:
		const blurIntensity = Math.min(width, height) / 10;
		src = addQueryParamToUrl(src, 'blur', blurIntensity.toString());
		srcSet = addQueryParamToSrcset(srcSet, 'blur', blurIntensity.toString());
	}

	return (
		<figure className={classnames(className, styles.figure)}>
			<img
				alt={alt || ''}
				className={styles.image}
				height={height}
				loading={loading}
				sizes={sizes}
				src={src}
				srcSet={srcSet}
				width={width}
			/>
			{hasCaption && title ? (
				<figcaption className={classnames(styles.caption, 'font-t6')}>
					<p>{title}</p>
				</figcaption>
			) : null}
		</figure>
	);
};
